module.exports = __webpack_public_path__ + "static/media/mssg_getstarted_pt_PT.9081fd98.png";